import api from "../services/api";

// Report Reason Categories
export const addReportReasonCategory = (data) => {
    return api.post('admin/reportReasons/add_category', data);
}

export const updateReportReasonCategory = (data) => {
    return api.put('admin/reportReasons/update_category', data);
}

export const updateReportReasonCategoryStatus = (data) => {
    return api.put('admin/reportReasons/update_category_status', data);
}

export const deleteReportReasonCategory = (id) => {
    return api.delete('admin/reportReasons/delete_category', {
        data: { _id: id }
    });
}

export const getReportReasonCategories = (queryParams) => {
    return api.get(`admin/reportReasons/category_list${queryParams}`);
};

// Report Reasons
export const createReportReason = (data) => {
    return api.post('admin/reportReasons/add_sub_category', data);
}

export const updateReportReason = (data) => {
    return api.put('admin/reportReasons/update_sub_category', data);
}

export const updateReportReasonStatus = (data) => {
    return api.put('admin/reportReasons/update_sub_category_status', data);
}

export const deleteReportReason = (id) => {
    return api.delete('admin/reportReasons/delete_sub_category', {
        data: { _id: id }
    });
}

export const getReportReasons = (queryParams) => {
    return api.get(`admin/reportReasons/sub_category_list${queryParams}`);
};